import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadMemberTextAlertMobileUpdateBatch = (formData) =>
  axios.post(`${BASE_URL}/members/batch-text-alert-mobile-update/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getMemberTextAlertMobileUpdateBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/members/batch-text-alert-mobile-update/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getMemberTextAlertMobileUpdateBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/members/batch-text-alert-mobile-update/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportMemberTextAlertMobileUpdateBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/members/batch-text-alert-mobile-update/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshMemberTextAlertMobileUpdateBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/members/batch-text-alert-mobile-update/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
